import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { PlatformService } from '../services/platform.service';

/** Exige plataforma escolhida + sessão válida (ou renovável via /me + interceptor). */
export const authGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const platform = inject(PlatformService);
  const router = inject(Router);

  if (!platform.hasSelection()) {
    return router.parseUrl('/select-platform');
  }

  // A plataforma salva só é honrada quando há sessão ativa. Sem sessão válida,
  // NÃO caímos direto no login da última plataforma — voltamos à seleção.
  return auth.ensureUser().pipe(map((user) => (user ? true : router.parseUrl('/select-platform'))));
};
